import { createTheme } from '@mui/material/styles';

// Single source of truth for the brand color already used by hand-written
// CSS (login/header/sidebar). Without this, every default MUI component
// (buttons, focused inputs, DataGrid selection, etc.) fell back to MUI's
// stock blue (#1976d2), clashing with the brand blue used elsewhere.
const theme = createTheme({
  palette: {
    primary: {
      main: '#0d4c92',
    },
    background: {
      default: '#f3f5f9',
    },
    text: {
      primary: '#1d2939',
      secondary: '#667085',
    },
    divider: '#e4e8ef',
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 12,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 14,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 600,
          backgroundColor: '#f7f9fc',
          color: '#475467',
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: '1px solid #e4e8ef',
          borderRadius: 10,
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#f7f9fc',
            color: '#475467',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 600,
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: 'rgba(13, 76, 146, 0.04)',
          },
          '& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus': {
            outline: 'none',
          },
        },
      },
    },
  },
});

export default theme;
